
        require('./index.scss');
        'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _home = require('model/service/home');

var _home2 = _interopRequireDefault(_home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;
var $mod = $('.module-home-feed');
var cacheDisabled = $mod.data('cache');
var feedTmpl = require('./feed-async.html');
var lazyLoad = require('assets/util/lazy-load.js');

var _module = {
    tag: $mod.find('.tab-nav-item.tab-nav-active').data('type') || '',
    pageIndex: 2,
    scrollLoad: false,
    lock: false,
    noMoreData: false,
    store: 0,
    init: function init() {
        this.freeDesign();
        this.tagChange();
        this.feedload();
        if (lazyLoad && typeof lazyLoad == 'function') {
            lazyLoad('.module-home-feed', '.homeFeed');
        }
    },
    freeDesign: function freeDesign() {
        $mod.on('click', '.free-design', function () {
            Event.trigger('design-block-show');
        });
    },
    tagChange: function tagChange() {
        var that = this;
        $mod.find('.tab-nav-item').click(function () {
            var $container = $(this);
            that.tag = $(this).data('type') || '';
            that.pageIndex = 1;
            that.scrollLoad = true;
            that.feedGet.call(that, true).then(function () {
                $container.addClass('tab-nav-active').siblings().removeClass('tab-nav-active');
            });
            $mod.find('.tab-nav .more').attr('href', $(this).data('more_url'));
        });
    },
    feedGet: function feedGet(vain) {
        var _this = this;

        $mod.find('.click-more').hide();
        $mod.find('.loading').show();
        this.lock = true;
        if (!this.tag && vain) {
            $mod.find('.feed-container').html(this.store);
            this.scrollLoad = false;
            this.lock = false;
            $mod.find('.click-more').show();
            $mod.find('.loading').hide();
            this.pageIndex++;
            return _promise2['default'].resolve();
        }

        return _home2['default'].getHomeFeed({
            pageNo: this.pageIndex,
            category: this.tag,
            cacheDisabled: cacheDisabled
        }).then(function (res) {
            if (res.code != 200 || !res.data) {
                return;
            }
            if (!_this.store) {
                _this.store = $mod.find('.feed-container').html();
            }
            if (vain) {
                $mod.find('.feed-container').html('');
            }
            $mod.find('.feed-container').append(velocityjs.render(feedTmpl, { designInfos: res.data.list }));
            _this.scrollLoad = !_this.scrollLoad;
            if (vain) {
                _this.scrollLoad = false;
            }
            _this.lock = false;
            $mod.find('.click-more').show();
            $mod.find('.loading').hide();
            _this.pageIndex++;

            if (res.data && res.data.pagination && res.data.pagination.currentPage >= res.data.pagination.totalPage) {
                $mod.find('.click-more').hide();
                $mod.find('.no-more-data').show();
            } else {
                $mod.find('.click-more').show();
                $mod.find('.no-more-data').hide();
            }
        }, function (err) {
            _this.lock = false;
            $mod.find('.click-more').show();
            $mod.find('.loading').hide();
        });
    },
    feedload: function feedload() {
        var that = this;
        $mod.find('.click-more').click(this.feedGet.bind(this, false));

        var winHeight = $(window).height();

        $(window).on('scroll', function () {
            if (!that.scrollLoad || that.lock || that.noMoreData) {
                return;
            }
            var $feedContainer = $mod.find('.feed-container');
            var scrollTop = $(window).scrollTop();
            if (scrollTop > $feedContainer.offset().top + $feedContainer.height() - winHeight) {
                that.feedGet.call(that, false);
            }
        });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-index/feed/index.js